<app-soft-deletable-auditable-translatable-lookups [paginationResponseResolver]="client"
  [defaultPaginationParameters]="defualtPaginationParameters" [supportedActions]="supportedActions" [tableConfig]="{
    fields: [
      { name: translate.currentLang === 'ar' ? 'city.arabicName' : 'city.englishName', displayName: 'GENERAL.CITY' }
    ],
    template: tableRowTemplate
  }" />

<ng-template #tableRowTemplate let-element>
  <td>{{ translate.currentLang === 'ar' ? element.city.arabicName : element.city.englishName }}</td>
</ng-template>
